<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold;">Nuevo interlocutor comercial</label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
    tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">


      <button tabindex="22" type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarCliente()"><i
          class="fa fa-save"></i>
        Guardar </button>
      <button (keydown.tab)="onNexFocus('Insert')" tabindex="23" type="button"
        class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()"><i class="fa fa-times-circle"></i>
        Cancelar </button>


      <div class="card">
        <div class="card-body">
          <div [hidden]="vista !== 1">
            <ngb-tabset>
              <ngb-tab title="Interlocutor comercial">
                <ng-template ngbTabContent>
                  <div class="card-body">

                    <button class="btn btn-outline-dark" routerLinkActive="active" (click)="importarDatosSunat()"
                      id="btnImportar"><img src="./assets/img/Sunat.ico"
                        style="width: 16px;height: 16px;margin-left: -.5rem" />Importar de
                      SUNAT</button>

                    <button class="btn btn-outline-dark" routerLinkActive="active" (click)="importarDatosDNI()"
                      id="btnImportar"><i class="far fa-address-card"></i> Importar DNI</button>

                    <hr>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Tipo de persona:
                          </label>
                          <div class="col-sm-2">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect "
                              (change)="onSelectTipoPersonaIns($event.target.value)" id="codtpe" name="codtpe"
                              [(ngModel)]="objCliente.codtpe" #selectInsertar tabindex="1">
                              <option *ngFor="let lst of tipopersona ;" value="{{lst.codtpe}}">
                                {{lst.destpe}}</option>
                            </select>
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                          <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Ingreso:
                          </label>
                          <div class="col-sm-2">
                            <input disabled type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.fecing" name="fecing" maxlength="3">
                          </div>
                          <div class="col-sm-3" style="margin-left: 2em;">
                            <input type="checkbox" class="form-check-input" id="exampleCheck1"
                              [(ngModel)]="objCliente.valident" name="valident">
                            <label class="tsiLabel form-check-label ajuste-check-label" for="exampleCheck1">Valida
                              identidad</label>
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Tipo de identidad:
                          </label>
                          <div class="col-sm-3">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect " id="tident"
                              name="tident" (change)="onSelectTipoIdentidadIns($event.target.value)"
                              [(ngModel)]="objCliente.tident" tabindex="4">
                              <option *ngFor="let tipdoci of identidades ;" value="{{tipdoci.tident}}">
                                {{tipdoci.descri}}</option>
                            </select>
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2"
                            style=" margin-left: -17px;">Doc. de identidad:
                          </label>
                          <div class="col-sm-3">
                            <input onkeypress='return event.charCode >= 48 && event.charCode <= 57' type="text"
                              (blur)="onBlurDocIdentidad()"
                              class="focus-input input_border form-control tsiInput no-border"
                              [(ngModel)]="objCliente.dident" name="dident" #dident [maxlength]="tamanoidentidad"
                              (keyup)="oneKeyupIdentidad($event)" tabindex="5">
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px;">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="disable_codigo" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objCliente.codcli"
                              name="codcli" maxlength="20" tabindex="6">
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                        </div>
                        <div *ngIf="tident=='06'">
                          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellidos y nombres:
                            </label>
                            <div class="col-sm-8">
                              <input type="text" class="focus-input input_border form-control tsiInput"
                                [(ngModel)]="objCliente.razonc" name="razonc" (keyup)="onKeyUpNombresCompletos($event)"
                                maxlength="75" tabindex="7">
                            </div>
                            <span style="
                            color: red;
                            font: sans-serif;
                            margin-left: -17px;
                          ">(*)</span>
                          </div>
                        </div>
                        <div *ngIf="tident!='06'">
                          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Razón social:
                            </label>
                            <div class="col-sm-8">
                              <input type="text" class="focus-input input_border form-control tsiInput"
                                [(ngModel)]="objCliente.razonc" name="razonc" maxlength="75" tabindex="7">
                            </div>
                            <span style="
                            color: red;
                            font: sans-serif;
                            margin-left: -17px;
                          ">(*)</span>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección 1:
                          </label>
                          <div class="col-sm-8">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.direc1" name="direc1" maxlength="92" tabindex="8">
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección 2:
                          </label>
                          <div class="col-sm-8">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.direc2" name="direc2" maxlength="92" tabindex="9">
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellido paterno:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.apellidopaterno" name="apellidopaterno" maxlength="20"
                              tabindex="10">
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Correo electrónico:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.email" name="email" maxlength="40" tabindex="11">
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellido materno:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.apeliidomaterno" name="apeliidomaterno" maxlength="20"
                              tabindex="12">
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Teléfono:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.telefono" name="telefono" maxlength="25" tabindex="13">
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Nombres:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.nombres" name="nombres" maxlength="20" tabindex="14">
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Celular:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objCliente.fax" name="fax" maxlength="25" tabindex="15">
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">DNI:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="identidad" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objCliente.nrodni"
                              name="nrodni" maxlength="15" tabindex="16">
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Sexo:
                          </label>
                          <div class="col-sm-3">
                            <select tabindex="17" class="col-sm-12 focus-input input_border  select_border tsiSelect "
                              id="sexo" name="sexo" [(ngModel)]="objCliente.sexo">
                              <option value="M">Masculino</option>
                              <option value="F">Femenino</option>
                            </select>
                          </div>


                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Vendedor:
                          </label>
                          <div class="col-sm-4">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect "
                              id="objCliente.codven" name="objCliente.codven" [(ngModel)]="objCliente.codven"
                              tabindex="18">
                              <option *ngFor="let vend of vendedores" value="{{vend.codven}}">
                                {{vend.descven}}</option>
                            </select>
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Título de lista:
                          </label>
                          <div class="col-sm-4">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect "
                              id="objCliente.codtit" name="objCliente.codtit" [(ngModel)]="objCliente.codtit"
                              tabindex="19">
                              <option *ngFor="let tit of titulolista" value="{{tit.codtit}}">
                                {{tit.titulo}}</option>
                            </select>
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                        </div>

                        <div class="form-group row d-flex align-items-center">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Concepto impositivo:
                          </label>
                          <div class="col-sm-5">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect "
                              id="objCliente.regret" name="objCliente.regret" [(ngModel)]="objCliente.regret"
                              tabindex="20">
                              <option *ngFor="let lst of clienteRegimenes" value="{{lst.codigo}}">
                                {{lst.descri}}</option>
                            </select>
                          </div>
                          <span style="
                          color: red;
                          font: sans-serif;
                          margin-left: -17px;
                        ">(*)</span>
                        </div>

                        <div class="form-group row d-flex" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Observación:
                          </label>
                          <div class="col-sm-8">
                            <textarea
                              class="focus-input input_border form-control-sm select_border form-control ajuste-textarea"
                              id="observ" name="observ" [(ngModel)]="objCliente.observ"
                              style="text-transform:uppercase;" type="text" rows="6" maxlength="980"
                              tabindex="21"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>

                  </div>
                </ng-template>
              </ngb-tab>
              <!-- <ngb-tab>
              <ng-template ngbTabTitle><b>Clases</b></ng-template>
              <ng-template ngbTabContent>

                <hr>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-3">
                        <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="open1(content1,'clase')"><i
                            class="fa fa-plus"></i> Nuevo </button>
                        <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="open1(content3,'ubigeo')"><i
                            class="fa fa-plus"></i> Ubigeo </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                    <thead>
                      <tr>
                        <th> </th>
                        <th>Clase</th>
                        <th>Descripción</th>
                        <th>Código</th>
                        <th>Descripción</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let lst of clases">
                        <td>
                          <span>
                            <button type="button" class="btn btn-sm" (click)="open2(content2 , lst)"><span
                                class="fas fa-pencil-alt" aria-hidden="true"></span></button>
                          </span>
                        </td>
                        <td>{{lst.clase}}</td>
                        <td>{{lst.desclase}}</td>
                        <td>{{lst.codigo}}</td>
                        <td>{{lst.descodigo}}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>



              </ng-template>
            </ngb-tab> -->
            </ngb-tabset>
            <!-- Nueva Clase-->
            <ng-template #content1 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Nueva Clase:</h4>
                <button tabindex="100" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>

                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Clase:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="codClase"
                              name="codClase" type="text"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3" disabled
                              tabindex="101">
                          </div>
                          <div class="col-md-7">
                            <select tabindex="102" class="col-md-12 focus-input input_border  select_border tsiSelect "
                              [(ngModel)]="codClase" (change)="onChangeClases($event.target.value)" name="codClase"
                              #selectClase>
                              <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                                {{claseSele.codigo+' - '+claseSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Código:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="codCodigoClase"
                              name="codCodigoClase" type="text" tabindex="103"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3">
                          </div>
                          <div class="col-md-7">
                            <select [disabled]="disabledCodigosClaseCombo" tabindex="104"
                              class="col-md-12 focus-input input_border  select_border tsiSelect "
                              [(ngModel)]="codCodigoClase" name="codCodigoClase" #selectClase>
                              <option *ngFor="let codigoSele of listacodigos" value="{{codigoSele.codigo}}">
                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarClase();"
                  tabindex="105">
                  <i class=" fas fa-angle-double-right"></i> Continuar</button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="106"><i class="fa fa-times-circle"></i>
                  Cancelar</button>
              </div>
            </ng-template>
            <!-- Modifica Clase-->
            <ng-template #content2 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Modificar Clase:</h4>
                <button tabindex="200" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>

                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Clase:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="editinputcla"
                              name="editinputcla" type="text" tabindex="201"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3" disabled>
                          </div>
                          <div class="col-md-7">
                            <select disabled tabindex="202" class="col-md-12 focus-input input_border  select_border tsiSelect "
                              [(ngModel)]="editinputcla" name="editinputcla" #selectClase style="color: black;">
                              <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                                {{claseSele.codigo+' - '+claseSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Código:</label>
                          <div class="col-md-2">
                            <input disabled style="text-align: center;" class="form-control"
                              [(ngModel)]="editinputcodigo" name="editinputcodigo" type="text" tabindex="203"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3">
                          </div>
                          <div class="col-md-7">
                            <select tabindex="204" class="col-md-12 focus-input input_border  select_border tsiSelect " [(ngModel)]="editinputcodigo"
                              name="editinputcodigo" #selectClase>
                              <option *ngFor="let codigoSele of listacodigos" value="{{codigoSele.codigo}}">
                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarActualizarClase();"
                  tabindex="205"><i class=" fas fa-angle-double-right"></i> Continuar</button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="206"><i class="fa fa-times-circle"></i>
                  Cancelar</button>

              </div>
            </ng-template>
            <!-- Nuevo Ubigeo-->
            <ng-template #content3 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Nuevo Ubigeo:</h4>
                <button tabindex="300" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>

                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Ubigeo:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="inputclase"
                              name="inputclase" type="text" tabindex="301"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3" disabled>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Departamento:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="inputclase"
                              name="inputclase" type="text" tabindex="302"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3" disabled>
                          </div>
                          <div class="col-md-7">
                            <select tabindex="303" class="col-md-12 focus-input input_border  select_border tsiSelect " [(ngModel)]="inputclase" name="inputclase"
                              #selectClase>
                              <option *ngFor="let claseSele of clasesSelect" value="{{claseSele.codigo}}">
                                {{claseSele.codigo+' - '+claseSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Provincia:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="inputclase"
                              name="inputclase" type="text" tabindex="304"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3" disabled>
                          </div>
                          <div class="col-md-7">
                            <select tabindex="305" class="col-md-12 focus-input input_border  select_border tsiSelect " [(ngModel)]="inputclase" name="inputclase"
                              #selectClase>
                              <option *ngFor="let claseSele of clasesSelect" value="{{claseSele.codigo}}">
                                {{claseSele.codigo+' - '+claseSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                        <div class="form-group row" style="margin-bottom: 0.5rem;">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-2 control-label col-form-label">Distrito:</label>
                          <div class="col-md-2">
                            <input style="text-align: center;" class="form-control" [(ngModel)]="inputclase"
                              name="inputclase" type="text" tabindex="306"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="3" disabled>
                          </div>
                          <div class="col-md-7">
                            <select tabindex="307" class="col-md-12 focus-input input_border  select_border tsiSelect "[(ngModel)]="inputclase" name="inputclase"
                              #selectClase>
                              <option *ngFor="let claseSele of clasesSelect" value="{{claseSele.codigo}}">
                                {{claseSele.codigo+' - '+claseSele.descri}}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarActualizarClase();"
                  tabindex="308"><i class=" fas fa-angle-double-right"></i> Continuar</button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="modal.close('Save click')"
                  tabindex="309"><i class="fa fa-times-circle"></i> Cancelar</button>

              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>